// Stockage des jetons JWT dans localStorage : survit à la fermeture du
// navigateur/onglet, ce qui permet la connexion automatique (mobile et desktop).
const ACCESS_KEY = 'rentman_access_token';
const REFRESH_KEY = 'rentman_refresh_token';

export const getAccessToken = () => localStorage.getItem(ACCESS_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY);

export const setTokens = ({ access, refresh }) => {
  if (access) localStorage.setItem(ACCESS_KEY, access);
  if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};
